import { Form } from '@/components/ui/form';

import type { GradeScaleEditor } from './useGradeScaleEditor';

import { GradeScalePreviewBar } from './GradeScalePreviewBar';
import { GradeScaleSchemeList } from './GradeScaleSchemeList';
import { GradeScaleTable } from './GradeScaleTable';

export interface GradeScaleEditorContentProps {
  editor: GradeScaleEditor;
}

export function GradeScaleEditorContent(gradeScaleEditorContentProps: GradeScaleEditorContentProps) {
  const { editor } = gradeScaleEditorContentProps;

  return (
    <Form {...editor.form}>
      <div className="flex grow flex-col gap-6 md:flex-row">
        <aside className="flex flex-col gap-3 md:w-64 md:shrink-0">
          <h3 className="text-foreground text-base font-semibold">Schematy</h3>
          <GradeScaleSchemeList schemes={editor.schemes} selectedIndex={editor.selectedIndex} onSelect={editor.selectScheme} />
        </aside>

        <section className="flex min-w-0 flex-1 flex-col gap-4">
          <h3 className="text-foreground text-base font-semibold">Skala ocen</h3>

          {editor.selectedScheme && (
            <>
              <GradeScalePreviewBar bands={editor.selectedScheme.bands} onMoveBoundary={editor.changeBandMax} onAddSeparator={editor.addBandAt} />
              <GradeScaleTable schemeIndex={editor.selectedIndex} bands={editor.selectedScheme.bands} onChangeMin={editor.changeBandMin} onChangeMax={editor.changeBandMax} />
            </>
          )}
        </section>
      </div>
    </Form>
  );
}
